import { NotificationPreferenceRecord } from '~/modules/notifications/types';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const notificationPreferencesQueryAtom = createQueryAtomFactory(
  'notifications.preferences',
  () => ({
    notificationPreferences: {
      __args: {
        pagination: { offset: 0, limit: 500 },
      },
      entries: {
        id: true,
        userId: true,
        notificationTypeKey: true,
        channel: true,
        enabled: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.notificationPreferences?.entries?.map(
        (p): NotificationPreferenceRecord => ({
          id: p.id,
          userId: p.userId,
          notificationTypeKey: p.notificationTypeKey,
          channel: p.channel,
          enabled: p.enabled,
        }),
      ) ?? [],
    staleTime: 60_000,
  },
);
